import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { Icon } from "./Icon";

class Button extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    icon: PropTypes.string,
    iconClassName: PropTypes.string,
    label: PropTypes.string,
    labelClass: PropTypes.string,
    onClick: PropTypes.func,
    type: PropTypes.string,
    withArrowDown: PropTypes.bool
  };

  static defaultProps = {
    className: "",
    disabled: false,
    icon: "",
    iconClassName: "",
    label: "",
    withArrowDown: false
  };

  render() {
    const { className, disabled, onClick, icon, iconClassName, labelClass, label, withArrowDown, type } = this.props;
    return (
      <button className={classNames("button", className, disabled && "--disabled")} onClick={onClick} disabled={disabled} type={type}>
        {icon && <Icon className={classNames("button__icon", iconClassName)} id={icon} />}
        <span className={labelClass}>{label}</span>
        {withArrowDown && <Icon id="arrow-down" className="button__arrow-down" />}
      </button>
    );
  }
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/Common/Button.js